import { gql } from '@apollo/client';

export const CHECK_PROMOTION = gql`
  query checkPromotion(
    $promotionName: String!
    $promotionFields: promotionFieldsInput
  ) {
    checkPromotion(
      promotionName: $promotionName
      promotionFields: $promotionFields
    )
  }
`;
